import { useAppSelector } from '@/hooks/useRedux';

export const priceBeforeCurrencySymbols = ['€', 'kr', 'KUBE'];

interface IProps {
    price: number | string | undefined;
}

export const usePriceCurrency = () => {
    const currencySymbol = useAppSelector((state) => state.booking.currency.symbol);
    const priceIsBefore = priceBeforeCurrencySymbols.includes(currencySymbol);

    const getPriceCurrency = (price: number | string | undefined) => {
        return `${priceIsBefore ? price : ''}${currencySymbol}${!priceIsBefore ? price : ''}`;
    };

    const PriceCurrency = ({ price }: IProps) => {
        if (typeof price === 'undefined') return null;

        return (
            <>
                {priceIsBefore && price}
                {currencySymbol}
                {!priceIsBefore && price}
            </>
        );
    };

    return { getPriceCurrency, PriceCurrency };
};

export default usePriceCurrency;
